import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import { ConstrainedText } from '~components/Text';
import Quote from '~components/Quote';

// Page Navigation
import PageNav from '~components/PageNav';
import AcceleratingResearchCard from '~components/PageCard/AcceleratingResearchCard';
import CellReplacementCard from '~components/PageCard/CellReplacementCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO
        title="Partenariat pour vaincre le diabète IRSC-FRDJ à l’aide de nouvelles thérapies et de technologies interactives afin de réduire le risque d’hypoglycémie"
        desc="Description"
      />
      <Hero title="Partenariat pour vaincre le diabète IRSC-FRDJ à l’aide de nouvelles thérapies et de technologies interactives afin de réduire le risque d’hypoglycémie">
        <StaticImage style={heroImgStyles} src="../../images/new-therapies.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        L’hypoglycémie (faible taux de sucre) est un problème essentiel chez bon nombre de Canadiens touchés par le diabète de type 1 (DT1).
        </ConstrainedText>
        <ConstrainedText>
        L’étude BETTER (BEhaviors, Therapies, TEchnologies and hypoglycemic Risk in type 1 diabetes) se concentre sur la mesure et la réduction de l’hypoglycémie chez les personnes touchées par le DT1. L’hypoglycémie est un problème courant et l’une des plus grandes peurs chez les personnes touchées par la maladie. Il s’agit d’une diminution du taux sanguin. Les symptômes incluent le tremblement, des sueurs, de la confusion et des étourdissements. L’hypoglycémie et la peur de l’hypoglycémie représentent les plus grands obstacles face à la gestion optimale de la DT1 et peuvent avoir un impact extrêmement négatif sur la qualité de vie. 
        </ConstrainedText>
        <ConstrainedText>
        Dr Rémi Rabasa-Lhoret et son équipe à l’Institut de recherches cliniques de Montréal (IRCM) ont développé un registre des personnes touchées par le DT1 qui les aide à mieux identifier les besoins et les réalités liés à cette maladie. Le registre comprend désormais plus de 1 800 personnes touchées au Québec. Ils mènent également plusieurs petites études en vue de mettre au banc d’essais des approches novatrices pour le traitement de l’hypoglycémie, incluant une plateforme en ligne interactive qui propose des ressources virtuelles et des occasions de réseauter avec d’autres personnes vivant avec le DT1. 
        </ConstrainedText>
        <Quote>
        « Notre objectif principal est d’identifier les mesures fructueuses qui peuvent être implantées quotidiennement pour améliorer le contrôle sanguin global, mentionne Dr Rabasa-Lhoret. Nous espérons que ce registre, de même que les futures études cliniques visant à optimiser les technologies et les thérapies, aidera à réduire le risque et le fardeau de l’hypoglycémie. »
        </Quote>
        <ConstrainedText>
        La pandémie a potentiellement ralenti la progression de l’étude. Mais Dr Rabasa-Lhoret et son équipe ont été en mesure de s’ajuster rapidement et d’optimiser l’accessibilité à leur plateforme virtuelle aux personnes touchées par le DT1 au Québec durant la pandémie de COVID.
        </ConstrainedText>
        <PageNav previous={<AcceleratingResearchCard />} next={<CellReplacementCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
